export enum Enemy {
  Normal,
  Boss
}
